<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Create a New Supplier</h4>
                <p class="text-subtitle-1">Supplier Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <SupplierForm
                    ref="SupplierForm"
                    @submit="handleSubmit"
                    @error="handleError"
                    @loading="handleLoading"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleCancel">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
    <PAlert v-bind="alert" v-model="alertShown"/>
    <v-snackbar bottom right v-model="snackbar.value" :color="snackbar.color">{{snackbar.text}}</v-snackbar>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import SupplierForm from './../../components/purchase/SupplierForm';
import PAlert from './../../components/common/PAlert';
import { v4 as uuid } from 'uuid';

import { mapActions, mapGetters } from 'vuex';

export default {
    name: "SupplierCreateView",
    components: {
        SupplierForm,
        PAlert,
    },
    data() {
        return {
            alertShown: false,
            alert: {
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            snackbar: {
                value: false,
                color: "primary",
                text: ""
            },
            loading: false,
            perm: permissions,
            idempotentKey: null
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            showSnackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = { ...this.alert, content: "Are you sure you want to save?", callback: this.save };
            this.alertShown = true;
        },
        save() {
            this.$refs.SupplierForm.submit(this.idempotentKey);
        },
        handleCancel() {
            this.alert = { ...this.alert, content: "Are you sure you want to discard changes?", callback: this.cancel };
            this.alertShown = true;
        },
        cancel() {
            this.$router.back();
        },
        handleSubmit(supplier) {
            this.showSnackbar({color: "success", text: "Supplier Created Successfully!"})
            this.$router.push({name: "SupplierDisplay", params: { id: supplier.id }})
        },
        handleError(err) {
            this.showSnackbar({color: "error", text: err})
        },
        handleLoading(value) {
            this.loading = value;
        },
        handleList() {
            this.$router.push({ name: "SupplierList"})
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
} 
</script>

<style>

</style>